import React, { useState, useEffect } from 'react';

const translations = {
  BE: {
    message: 'Toegang tot uw gegevens en documenten via de nieuwe beta versie van My Yuso Services - ',
    urlText: 'https://my.services.yuso.io',
  },
  FR: {
    message: 'Accédez à vos données et documents sur la nouvelle version bêta de My Yuso Services - ',
    urlText: 'https://my.services.yuso.io',
  },
  default: {
    message: 'Access your data and documents on the new beta version of My Yuso Services - ',
    urlText: 'https://my.services.yuso.io',
  },
};

const Banner = () => {
  // const [showBanner, setShowBanner] = useState(false);
  // const [bannerHeight, setBannerHeight] = useState(0);
  const [location, setLocation] = useState('default');

  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then((response) => response.json())
      .then((data) => {
        const countryCode = data.country_code;
        setLocation(countryCode);
      })
      .catch(() => {
        setLocation('default');
      });

    // const showTimeout = setTimeout(() => {
    //   setShowBanner(true);
    //   setBannerHeight(50);
    // }, 500);

    // const hideTimeout = setTimeout(() => {
    //   setShowBanner(false);
    //   setBannerHeight(0);
    // }, 10000);

    // return () => {
    //   clearTimeout(showTimeout);
    //   clearTimeout(hideTimeout);
    // };
  }, []);

  const translation = translations[location] || translations.default;

  return (
    <>
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '45px',
            backgroundColor: '#186087',
            color: '#fff',
            textAlign: 'center',
            padding: '10px',
            zIndex: 10000,
          }}
        >
          {translation.message}{' '}
          <a href={translation.urlText} style={{ color: '#fff', textDecoration: 'underline' }}>
            {translation.urlText}
          </a>
        </div>

      {/* <div style={{ marginTop: `${40}px`, transition: 'margin-top 0.5s ease-in-out' }}></div> */}
    </>
  );
};

export default Banner;
